import moment from "moment";
import numbro from "numbro";
var CryptoJS = require("crypto-js");
const key = process.env.REACT_APP_COMMON_SECRET_KEY;

export const addArticle = (word) => {
  const vowels = ["a", "e", "i", "o", "u"];
  return vowels.includes(word?.[0]?.toLowerCase()) ? `an ${word}` : `a ${word}`;
};

export const GSTClaculate = (value, tax) => {
  return tax === 0
    ? 0
    : formatNumber(Number(Number(value) - (Number(value) / 1.1) * 0.1));
};

export const GSTClaculateWithouComma = (value, tax) => {
  return tax === 0 ? 0 : Number((Number(value) / 1.1) * 0.1);
};

export const ExGSTClaculate = (value, tax) => {
  return tax === 0
    ? formatNumber(Number(value))
    : formatNumber(Number(Number(value) - (Number(value) / 1.1) * 0.1));
};

export const ExGSTClaculateWithouComma = (value, tax) => {
  return tax === 0
    ? value
    : Number(Number(value) - (Number(value) / 1.1) * 0.1);
};

export const unformatNumber = (value) => {
  return numbro.unformat(value);
};

/**
 *
 * @param {Phone Number} phone
 * @returns {Formated Phone Number}
 */
export const formatPhone = (phone) => {
  // let format =
  //   phone.slice(0, 3) === "+61"
  //     ? phone.slice(0, 3) +
  //       " " +
  //       phone.slice(3, 4) +
  //       " " +
  //       phone.slice(4, 8) +
  //       " " +
  //       phone.slice(8, 12)
  //     : "+61 " +
  //       phone.slice(0, 1) +
  //       " " +
  //       phone.slice(1, 5) +
  //       " " +
  //       phone.slice(5, 9);
  let phoneData = phone;
  if (phoneData.slice(0, 3) === "+61") {
    phoneData = phoneData?.split("+61")[1];
  }
  if (phoneData.length < 10) {
    phoneData = `0${Number(phoneData)}`; // Pad with leading zeros to make it 10 digits
  }
  let format = `${String(phoneData).substring(0, 2)} ${String(
    phoneData
  ).substring(2, 6)} ${String(phoneData).substring(6)}`;
  return format;
};

/**
 *
 * @param {Mobile Number} mobile
 * @returns {Formated Mobile Number}
 */
export const formatMobile = (mobile) => {
  // let format =
  //   mobile.slice(0, 3) === "+61"
  //     ? mobile.slice(0, 3) +
  //       " " +
  //       mobile.slice(3, 6) +
  //       " " +
  //       mobile.slice(6, 9) +
  //       " " +
  //       mobile.slice(9, 12)
  //     : "+61 " +
  //       mobile.slice(0, 3) +
  //       " " +
  //       mobile.slice(3, 6) +
  //       " " +
  //       mobile.slice(6, 9);
  let mobileData = mobile;
  if (mobileData.slice(0, 3) === "+61") {
    mobileData = mobileData?.split("+61")[1];
  }
  if (mobileData.length < 10) {
    mobileData = `0${Number(mobileData)}`; // Pad with leading zeros to make it 10 digits
  }
  let format = `${String(mobileData).substring(0, 2)} ${String(
    mobileData
  ).substring(2, 6)} ${String(mobileData).substring(6)}`;
  return format;
};

/**
 *
 * @param {ABN Number} abn
 * @returns {Formated ABN Number}
 */
export const formatABN = (abn) => {
  let abnString = abn.toString();
  let format =
    abnString.slice(0, 2) +
    " " +
    abnString.slice(2, 5) +
    " " +
    abnString.slice(5, 8) +
    " " +
    abnString.slice(8, 11);

  return format;
};

/**
 *
 * @param {First Name} firstName
 * @param {Last Name} lastName
 * @returns {Formated Full Name}
 */
export const formatName = (firstName, lastName) => {
  let format =
    firstName && lastName
      ? firstName + " " + lastName
      : !firstName && lastName
      ? lastName
      : !lastName && firstName
      ? firstName
      : "";
  // let format = firstName ? firstName + " " + lastName : lastName;
  return format;
};

export const chartOfAccountFormat = (element) => {
  let format =
    element?.name +
    (element?.account_type?.name
      ? " (" + element?.account_type?.name + ")"
      : "") +
    (element?.code ? " - " + element?.code.toString() : "") +
    (element?.sub_code ? "." + element?.sub_code.toString() : "");
  return format;
};

/**
 *
 * @param {Street Name} street
 * @param {Suburb Name} suburb
 * @returns {Formated Office Name}
 */
export const formatOfficeName = (street, suburb) => {
  let format = street
    ? street + (suburb?.name ? ", " + suburb?.name : "")
    : suburb?.name
    ? suburb?.name
    : "";
  return format;
};

/**
 *
 * @param {Street Name} street
 * @param {Suburb Name} suburb
 * @param {State Name} state
 * @param {Postal Code} code
 * @returns {Formated Full Address}
 */
export const formatFullAddress = (street, suburb, state, code) => {
  let format = (
    <p>
      {street && street + " "} {suburb && suburb + " "} {state && state + " "}{" "}
      {code && code + " "}
    </p>
  );

  return format;
};

export const checkIfFileExists = (url, callback) => {
  const img = new Image();
  img.src = url;

  if (img.complete) {
    callback(true);
  } else {
    img.onload = () => {
      callback(true);
    };

    img.onerror = () => {
      callback(false);
    };
  }
};

export const formatAccountNumber = (number) => {
  // const formatedNumber = "XXXX XXXX " + number?.toString().slice(-4);
  const formatedNumber = number?.toString();
  return formatedNumber;
};

// export const formatBSBNumber = (number) => {
//   // const formatedNumber = "XXX-" + number?.toString().slice(-3);
//   const formatedNumber =
//     number?.toString()?.length === 6
//       ? `${number?.toString().slice(0, 3)}-${number?.toString().slice(-3)}`
//       : number?.toString();
//   return formatedNumber;
// };

export const formatBSBNumber = (value) => {
  if (!value) return "";

  // Remove all non-digits (like "-")
  const digits = value.toString().replace(/\D/g, "");

  // Pad to 6 digits (BSB must be 6 digits)
  const padded = digits.padStart(6, "0");

  // Format as XXX-XXX
  const formatted = `${padded.slice(0, 3)}-${padded.slice(3, 6)}`;

  return formatted;
};

export const formatNumber = (number) => {
  const formatedNumber = number
    ? number.toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
    : 0.0;

  return formatedNumber;
};

export const formatNumberWithoutComma = (number) => {
  const formatedNumber = parseFloat(number)
    ? parseFloat(number).toFixed(2)
    : 0.0;

  return formatedNumber;
};

/**
 *
 * @param {Street Name} street
 * @param {Suburb Name} suburb
 * @param {State Name} state
 * @param {Postal Code} code
 * @returns
 */
export const formatedAddress = (street, suburb, state, code) => {
  if (!street && !suburb && !state && !code) return "-";
  let address = "";
  if (street) address = `${street}${code || state || suburb ? ", " : ""}`;
  if (suburb) address += `${suburb}${code || state ? ", " : ""}`;
  if (state) address += `${state}${code ? ", " : ""}`;
  if (code) address += `${formatedPostalCode(code)}`;

  return address;
};

export const formatedInternationalAddress = (full_address, country) => {
  if (!full_address && !country) return "-";
  let address = "";
  if (full_address) address = `${full_address}${country ? ", " : ""}`;
  if (country) address += `${country}`;
  return address;
};

const today = new Date();
export const pastFinancialdate =
  parseInt(moment(today).format("MM")) === 7
    ? [new Date(today.getFullYear(), today.getMonth(), 1), new Date()]
    : parseInt(moment(today).format("MM")) > 7
    ? [new Date(new Date().getFullYear(), 6, 1), new Date()]
    : [new Date(new Date().getFullYear() - 1, 6, 1), new Date()];

export const lastTwoMonth = [
  new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1),
  new Date(),
];

export const formatedPostalCode = (n) => {
  const length = n ? n.toString().length : "";

  const format = length
    ? length === 4
      ? n
      : length === 3
      ? `0${n}`
      : length === 2
      ? `00${n}`
      : length === 1
      ? `000${n}`
      : ""
    : "";

  return format?.toString();
};

export const removeDuplicates = (arr) => {
  return arr.filter((item, index) => arr.indexOf(item) === index);
};

// const today = new Date();
let tomorrow = new Date();
tomorrow.setDate(today.getDate() + 1);
export const disabledFutureDates = [[tomorrow, false]];

const pastYear = new Date();
pastYear.setFullYear(pastYear.getFullYear() - 1);
const past2Year = new Date();
past2Year.setFullYear(past2Year.getFullYear() - 2);
// const past1days = new Date();
// past1days.setDate(past1days.getDate() - 1);
const past6days = new Date();
past6days.setDate(past6days.getDate() - 6);
const past13days = new Date();
past13days.setDate(past13days.getDate() - 13);
export const periods = [
  // { children: "Last 2 days", value: [past1days, new Date()] },
  { children: "Last Week", value: [past6days, new Date()] },
  { children: "Last 2 Weeks", value: [past13days, new Date()] },
  { children: "Last 12 Months", value: [pastYear, new Date()] },
  { children: "Last 24 Months", value: [past2Year, new Date()] },
];

export const removeString = (string, from, to) => {
  return [...string].filter((_, i) => i < from || i > to).join("");
};

const MAX_LIMIT_OF_NUMBER = 1000000000000000;
export const MaxLimit = (values) => {
  const { formattedValue, floatValue } = values;
  if (floatValue == null) {
    return formattedValue === "";
  } else {
    return floatValue < MAX_LIMIT_OF_NUMBER && floatValue >= 0;
  }
};

export const NegativeAmountConverter = (number) => {
  return (
    <>
      {number && Math.sign(number?.toFixed(2)) === -1
        ? "-$" +
          number

            .toLocaleString("en-US", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })
            ?.slice(1)
        : "$" +
          number?.toLocaleString("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}
    </>
  );
};

export const DDMMYYYYFormat = (data) => {
  return `${data[2]}-${data[1]}-${data[0]}`;
};

export const encrypt = (data) => {
  // Encrypt
  var ciphertext = CryptoJS.AES.encrypt(data, key).toString();
  return ciphertext;
};

export const decrypt = (ciphertext) => {
  // Decrypt
  var bytes = CryptoJS.AES.decrypt(ciphertext, key);
  var decryptedData = bytes.toString(CryptoJS.enc.Utf8);
  return decryptedData;
};

export const ExcelDateFormat = (data) => {
  return data
    ? data?.toString()?.includes("/")
      ? data?.split("/")?.join("-")
      : data
    : "";
};

export const formatSubcontractorName = (data) => {
  if (data?.joint_accounts?.length) {
    return formatVendorName(data);
  } else {
    let format =
      data?.business_name ===
      (data?.first_name && data?.last_name
        ? data?.first_name + " " + data?.last_name
        : !data?.first_name && data?.last_name
        ? data?.last_name
        : "")
        ? data?.business_name
        : data?.business_name
        ? `${data?.business_name} (${
            data?.first_name && data?.last_name
              ? data?.first_name + " " + data?.last_name
              : !data?.first_name && data?.last_name
              ? data?.last_name
              : ""
          })`
        : data?.first_name && data?.last_name
        ? data?.first_name + " " + data?.last_name
        : !data?.first_name && data?.last_name
        ? data?.last_name
        : "";

    // let format = firstName ? firstName + " " + lastName : lastName;
    return format;
  }
};

export function padWithLeadingZeros(num, totalLength) {
  return String(num).padStart(totalLength, "0");
}

export const maskPostalCode = (num) => {
  return padWithLeadingZeros(num, 4);
};

export const convertDateString = (dateString) => {
  // Extract the timestamp from the string
  const match = dateString.match(/\/Date\((\d+)\+\d+\)\//);
  if (!match) {
    return "Invalid date format";
  }

  const timestamp = parseInt(match[1], 10);

  // Convert timestamp to a Date object
  const date = new Date(timestamp);

  // Format the date as dd-mm-yyyy
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
  const year = date.getFullYear();

  return `${day}-${month}-${year}`;
};

const RoleTypeArray = ["Admin"];

export const checkRole = (roleType) => {
  if (RoleTypeArray.find((item) => item === roleType)) {
    return true;
  } else {
    return false;
  }
};

// export const formatUTCToLocal = (utcDateString, withTime = false) => {
//   if (!utcDateString) return "";

//   const localDate = new Date (utcDateString);

//   const day = String(localDate.getDate()).padStart(2, "0");
//   const month = String(localDate.getMonth() + 1).padStart(2, "0");
//   const year = localDate.getFullYear();

//   if (withTime) {
//     const hours = String(localDate.getHours()).padStart(2, "0");
//     const minutes = String(localDate.getMinutes()).padStart(2, "0");
//     return `${day}-${month}-${year} ${hours}:${minutes}`;
//   }

//   return `${day}-${month}-${year}`;
// };

export const formatUTCToLocal = (utcDateString, withTime = false) => {
  if (!utcDateString) return "";

  const localDate = new Date(utcDateString);

  const day = String(localDate.getDate()).padStart(2, "0");
  const month = String(localDate.getMonth() + 1).padStart(2, "0");
  const year = localDate.getFullYear();

  if (withTime) {
    let hours = localDate.getHours();
    const minutes = String(localDate.getMinutes()).padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12;
    hours = hours === 0 ? 12 : hours; // convert 0 (midnight) to 12
    const formattedHours = String(hours).padStart(2, "0");

    return `${day}-${month}-${year} ${formattedHours}:${minutes} ${ampm}`;
  }

  return `${day}-${month}-${year}`;
};

export const getFileNameFromUrl = (url) => {
  try {
    return url.split("/").pop()?.split("?")[0];
  } catch {
    return "document.pdf";
  }
};

export const extractModuleFromPath = (pathname) => {
  // Example: "/vendors/edit/1" -> "vendors"
  const segments = pathname.split("/").filter(Boolean);

  if (segments[0] === "trusts" && segments[1]) {
    return segments[2] || "";
  }
  if (segments[0] === "admin" && segments[1]) {
    return segments[1] || "";
  }
  return segments[0] || ""; // fallback to empty string if no path
};

export const getCookie = (name) => {
  const cookies = document.cookie.split("; ").reduce((acc, cookie) => {
    const [key, value] = cookie.split("=");
    acc[key] = value;
    return acc;
  }, {});
  return cookies[name];
};

export const capitalizeSingleWord = (str) => {
  if (!str) return "";
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};

export const CalculateGST = (amount_tax_type, type, totalAmount, TaxPerc) => {
  let TaxPercentage = TaxPerc && TaxPerc !== undefined ? TaxPerc : 10;
  let TaxValue =
    amount_tax_type === "1"
      ? Number(1 + Number(Number(TaxPercentage / 100).toFixed(2)))
      : Number(Number(TaxPercentage / 100).toFixed(2));

  return type === "1" // Tax Type of the item level
    ? amount_tax_type === "1"
      ? Number(
          Number(totalAmount) -
            Number(Number(totalAmount) / TaxValue).toFixed(2)
        ).toFixed(2)
      : Number(Number(totalAmount) * Number(TaxValue).toFixed(2)).toFixed(2)
    : 0;
};

export const CalculateAmountExcGST = (
  amount_tax_type,
  type,
  totalAmount,
  TaxPerc
) => {
  let TaxPercentage = TaxPerc && TaxPerc !== undefined ? TaxPerc : 10;
  let gst_price = CalculateGST(
    amount_tax_type,
    type,
    totalAmount,
    TaxPercentage
  );
  return type === "1"
    ? amount_tax_type === "1"
      ? Number(Number(totalAmount) - Number(gst_price)).toFixed(2)
      : Number(Number(totalAmount)).toFixed(2)
    : Number(totalAmount).toFixed(2);
};

export const formatDateTime = (date) => {
  const options = {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  };

  return date.toLocaleString("en-AU", options).replace(",", "");
};

export const formatContactName = (type, value, organizationData) => {
  return type === "contact"
    ? `${formatSubcontractorName(value)} - (${getModuleNamingBySlug(
        organizationData,
        "contacts",
        "C"
      )?.charAt(0)})`
    : type === "beneficiary"
    ? `${formatSubcontractorName(value)} - (B)`
    : type === "supplier"
    ? `${formatSubcontractorName(value)} - (S)`
    : type === "vendor"
    ? `${formatSubcontractorName(value)} - (${getModuleNamingBySlug(
        organizationData,
        "vendors",
        "V"
      )?.charAt(0)})`
    : type === "trust"
    ? value?.business_name
      ? value?.business_name
      : value?.first_name
      ? value?.first_name + " " + value?.last_name
      : value?.last_name
    : type === "contact"
    ? formatSubcontractorName(value)
    : "-";
};

export const formatContactNameType = (value, organizationData) => {
  return Number(value?.type) === 4
    ? `${formatSubcontractorName(value?.contact)} - (${getModuleNamingBySlug(
        organizationData,
        "contacts",
        "C"
      )?.charAt(0)})`
    : Number(value?.type) === 3
    ? `${formatSubcontractorName(value?.beneficiary)} - (B)`
    : Number(value?.type) === 2
    ? `${formatSubcontractorName(value?.supplier)} - (S)`
    : Number(value?.type) === 1
    ? `${formatSubcontractorName(value?.vendor)} - (${getModuleNamingBySlug(
        organizationData,
        "vendors",
        "V"
      )?.charAt(0)})`
    : Number(value?.type) === 0
    ? value?.trust?.business_name
      ? value?.trust?.business_name
      : value?.trust?.first_name
      ? value?.trust?.first_name + " " + value?.trust?.last_name
      : value?.trust?.last_name
    : "-";
};

export const getModuleNamingBySlug = (
  organizationData,
  targetSlug,
  defaultValue
) => {
  let organizationType = organizationData?.organization_type;
  if (!organizationType || !Array.isArray(organizationType?.module_namings))
    return defaultValue;

  const match = organizationType?.module_namings?.find(
    (naming) => naming.module?.slug === targetSlug
  );

  if (!match) return defaultValue;

  // Add 's' at the end if defaultValue ends with 's'
  if (defaultValue?.endsWith("s")) {
    return `${match.name}s`;
  }

  return match.name;
};

export const dateFormatReader = (value) => {
  var utc_days = Math.floor(value - 25569);
  var utc_value = utc_days * 86400;
  const date = new Date(utc_value * 1000);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
  const year = date.getFullYear();
  return `${year}-${month}-${day}`;
};

export const formatVendorName = (data) => {
  const {
    first_name,
    last_name,
    business_name,
    joint_accounts = [],
  } = data || {};

  // Fallback when no joint accounts

  // Combine main + joint accounts
  const allAccounts = [{ first_name, last_name }, ...joint_accounts];

  // Extract last names
  const lastNames = allAccounts.map((a) => a.last_name?.trim() || "");
  const uniqueLastNames = [...new Set(lastNames.filter(Boolean))];

  // Helper: format name as "D. Patel"
  // eslint-disable-next-line no-unused-vars
  const getName = (a) => {
    const f = a.first_name?.trim();
    const l = a.last_name?.trim();
    if (f && l) return `${f.charAt(0).toUpperCase()}. ${l}`;
    if (l) return l;
    return f?.charAt(0).toUpperCase() + "." || "";
  };

  // Helper: format full name
  const getFullName = (a) => {
    const f = a.first_name?.trim();
    const l = a.last_name?.trim();
    return [f, l].filter(Boolean).join(" ");
  };

  // Helper: join array as "A, B & C"
  const joinNames = (names) => {
    if (names.length <= 2) return names.join(" & ");
    return `${names.slice(0, -1).join(", ")} & ${names[names.length - 1]}`;
  };

  if (uniqueLastNames.length === 1) {
    // Same last name → combine first names + single last name
    const firstNames = allAccounts
      .map((a) => a.first_name?.trim())
      .filter(Boolean);
    const namesJoined = joinNames(firstNames);
    return business_name
      ? business_name
      : `${namesJoined} ${uniqueLastNames[0]}`;
  } else {
    // Different last names → use getName() for each
    // const formattedNames = allAccounts.map(getName);
    const formattedNames = allAccounts.map(getFullName);
    return business_name ? business_name : joinNames(formattedNames);
  }
};

export const formatDollarCents = (value) => {
  if (!value && value !== 0) return { dollars: "0", cents: "00" };

  // Ensure it's a number
  const num = Number(value);

  // Fix to 2 decimals → convert to string
  const fixed = num.toFixed(2); // "2100.02"

  // Split into 2 parts
  const [dollarsPart, centsPart] = fixed.split(".");

  // Add comma formatting to dollars
  const formattedDollars = Number(dollarsPart).toLocaleString("en-US");

  return {
    dollars: formattedDollars,
    cents: centsPart,
  };
};